var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#28C76F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3337 30V28.5C48.3337 27.5 47.667 26.8333 46.667 26.8333C45.667 26.8333 45.0003 27.5 45.0003 28.5V30C45.0003 38.3333 38.3337 45 30.0003 45C21.667 45 15.0003 38.3333 15.0003 30C15.0003 21.6666 21.667 15 30.0003 15C32.167 15 34.167 15.5 36.167 16.3333C37.0003 16.6666 38.0003 16.3333 38.3337 15.5C38.667 14.6666 38.3337 13.6666 37.5003 13.3333C35.167 12.1666 32.5003 11.6666 30.0003 11.6666C19.8337 11.6666 11.667 19.8333 11.667 30C11.667 40.1666 19.8337 48.3333 30.0003 48.3333C40.167 48.3333 48.3337 40.1666 48.3337 30ZM47.167 13.8333C47.8337 13.1666 48.8337 13.1666 49.5003 13.8333C50.167 14.5 50.167 15.5 49.5003 16.1666L31.167 34.5C30.8337 34.8333 30.3337 35 30.0003 35C29.667 35 29.167 34.8333 28.8337 34.5L23.8337 29.5C23.167 28.8333 23.167 27.8333 23.8337 27.1666C24.5003 26.5 25.5003 26.5 26.167 27.1666L30.0003 31L47.167 13.8333Z",
    fill: "#28C76F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.fb4f2207a7a7fe40a4872d8163cb6536.svg";
export { ForwardRef as ReactComponent };